import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment/moment';
import isEmpty from 'lodash/isEmpty';

import { Typography, Space, Form, Button } from 'antd';
import { ApplicationUIContext, Drawer, useDrawerState } from '@yuhuinc/ui-library';

import AddDeposit from './DepositComponents/AddDeposit';
import DepositsTable from './DepositComponents/DepositsTable';

import { getTranslatedString } from 'helpers/i18n';

const { Title } = Typography;

const StyledSpace = styled(Space)`
  width: 100%;
`;

const Deposits = ({ applicantDeposits = [] }) => {
  const { isMobile } = useContext(ApplicationUIContext);
  const [, addDepositDrawer] = useDrawerState(false);
  const form = Form.useFormInstance();

  useEffect(() => {
    if (!isEmpty(applicantDeposits)) {
      // pre-fill deposits table with any deposits from applicant
      const deposits = applicantDeposits.map((deposit) => ({
        amount: deposit.amount,
        date: moment(deposit.date),
        paid_in_person: true,
      }));
      form.setFieldsValue({ deposits });
    }
  }, [applicantDeposits]);

  return (
    <React.Fragment>
      <StyledSpace direction="vertical" size="middle">
        <Form.List name="deposits">
          {(fields, operations) => {
            const onDepositAdd = (deposit) => {
              operations.add(deposit);
            };
            return (
              <React.Fragment>
                <StyledSpace direction="vertical" size="middle">
                  <Title level={isMobile ? 4 : 5} style={{ margin: 0 }}>
                    {getTranslatedString(
                      'landlordPortal.applicationManagement.inviteLeadToApply.deposits.deposit'
                    )}
                  </Title>

                  {fields.length > 0 && <DepositsTable deposits={fields} operations={operations} />}

                  <Button size={isMobile && 'large'} onClick={addDepositDrawer.open}>
                    {getTranslatedString(
                      'landlordPortal.applicationManagement.inviteLeadToApply.deposits.addDeposit'
                    )}
                  </Button>
                  <Drawer
                    title={getTranslatedString(
                      'landlordPortal.applicationManagement.inviteLeadToApply.deposits.drawerTitle'
                    )}
                    visible={addDepositDrawer.isVisible}
                    closable
                    destroyOnClose
                    onClose={addDepositDrawer.close}
                  >
                    <AddDeposit closeDrawer={addDepositDrawer.close} onAdd={onDepositAdd} />
                  </Drawer>
                </StyledSpace>
              </React.Fragment>
            );
          }}
        </Form.List>
      </StyledSpace>
    </React.Fragment>
  );
};

export default Deposits;
